<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="消费登记"
      id-key="ConsumeId"
      :data="data"
      :form-rules="rules"
      :save-func="()=>{}"
      :confirm-on-close-change="false"
      @create-opened="onCreateOpened"
    >
      <template slot="form">
        <el-form-item label="设备名称" prop="DeviceId">
          <el-select v-model="data.DeviceId" filterable>
            <template v-for="(i,key) in devices">
              <el-option :key="key" :label="i.DeviceName" :value="i.DeviceId"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="人员类型">
          <el-radio v-model="data.MemberType" :label="0">学生</el-radio>
          <el-radio v-model="data.MemberType" :label="1">教职员工</el-radio>
        </el-form-item>
        <div v-loading="isLoading">
          <el-form-item label="人员编号" prop="MemberId">
            <el-select
              ref="mselect"
              remote
              filterable
              v-model="FetchStr"
              :remote-method="onFetch"
              :loading="fetching"
              @change="onSelect"
              clearable
            >
              <el-option v-for="(i,key) in members" :key="key" :value="i.MemberNo">
                <span>{{ i.MemberName }}</span>
                <span style="color: #b4b4b4;">（编号：{{ i.MemberNo }}）</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员姓名">
            <template v-if="data.MemberId">
              <span>{{data.MemberName}}</span>
              <span style="color: #b4b4b4;">（编号：{{ data.MemberNo }}）</span>
            </template>
          </el-form-item>
          <el-form-item label="消费金额" prop="ConsumeAmount">
            <el-input v-model="data.ConsumeAmount" v-num placeholder="请输入消费金额" clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item label="消费时间" prop="ConsumeTime">
          <el-date-picker
            v-model="data.ConsumeTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择消费时间"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  watch: {
    "data.DeviceId": {
      handler() {
        if (this.data.DeviceId) {
          var data = this.devices.find((x) => x.DeviceId == this.data.DeviceId);
          this.data.DeviceNo = data.DeviceNo;
          this.data.Ip = data.Ip;
        } else {
        }
      },
    },
    // "data.MemberType": {
    //   handler() {
    //     this.data.MemberId = null;
    //     this.data.MemberNo = "";
    //     this.data.MemberName = "";
    //   },
    // },
  },
  data() {
    return {
      data: {
        ConsumeId: 0,
        MemberType: 0,
        MemberId: null,
        MemberNo: "",
        MemberName: "",
        DeviceId: null,
        DeviceNo: "",
        ConsumeAmount: null,
        ConsumeTime: this.$commonJs.getNowDatetimeString(),
        Ip: "",
        Online: false,
      },
      FetchStr: "",
      members: [],
      devices: [],
      isLoading: false,
      fetching: false,
      isMB: this.$store.state.isMB,
      api: require("@/api/cp/consume").default,
      device_api: require("@/api/cp/device").default,
      student_api: require("@/api/st/student").default,
      teacher_api: require("@/api/fa/teacher").default,
      rules: {
        DeviceId: [{ required: true, message: "设备不能为空" }],
        MemberId: [{ required: true, message: "人员不能为空" }],
        ConsumeAmount: [{ required: true, message: "金额不能为空" }],
        ConsumeTime: [{ required: true, message: "消费时间不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.device_api.list({}).then((res) => {
        this.devices = res.Data;
      });
    },
    onChange() {
      this.FetchStr = "";
      this.members = [];
      this.data.MemberId = null;
      this.data.MemberNo = "";
      this.data.MemberName = "";
      this.$refs.dialog.clearValidate();
    },
    onFetch(str) {
      this.members = [];
      if (str) {
        if (this.data.MemberType == 0) {
          this.fetching = true;
          var params = { StudentNumber: str, PageIndex: 1, PageSize: 10 };
          this.student_api.list(params).then((res) => {
            this.fetching = false;
            this.members = res.Data.map((x) => ({
              ...x,
              MemberNo: x.StudentNumber,
              MemberId: x.StudentId,
              MemberName: x.FullName,
            }));
            if (this.members.length == 1) {
              this.FetchStr = this.members[0].MemberNo;
              this.data.MemberId = this.members[0].MemberId;
              this.data.MemberNo = this.members[0].MemberNo;
              this.data.MemberName = this.members[0].MemberName;
              this.$refs.mselect.blur();
            }
          });
        } else {
          this.fetching = true;
          var params = { TeacherNumber: str, PageIndex: 1, PageSize: 10 };
          this.teacher_api.list(params).then((res) => {
            this.fetching = false;
            this.members = res.Data.map((x) => ({
              ...x,
              MemberNo: x.TeacherNumber,
              MemberId: x.TeacherId,
              MemberName: x.TeacherName,
            }));
            if (this.members.length == 1) {
              this.FetchStr = this.members[0].MemberNo;
              this.data.MemberId = this.members[0].MemberId;
              this.data.MemberNo = this.members[0].MemberNo;
              this.data.MemberName = this.members[0].MemberName;
            }
          });
        }
      }
    },
    onSelect(data) {
      // console.log(JSON.parse(JSON.stringify(data)));
      if (data) {
        var member = this.members.find((x) => x.MemberNo == data);
        this.data.MemberId = member.MemberId;
        this.data.MemberNo = member.MemberNo;
        this.data.MemberName = member.MemberName;
      } else {
        this.FetchStr = "";
        this.members = [];
        this.data.MemberId = null;
        this.data.MemberNo = "";
        this.data.MemberName = "";
      }
      // console.log(JSON.parse(JSON.stringify(this.data)));
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        this.$refs.dialog.isLoading = true;
        this.api.save(this.data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.$emit("close-saved");
            this.FetchStr = "";
            this.members = [];
            this.data.ConsumeId = 0;
            this.data.MemberId = null;
            this.data.MemberNo = "";
            this.data.MemberName = "";
            this.data.ConsumeAmount = null;
            this.data.Ip = "";
            this.data.ConsumeTime = this.$commonJs.getNowDatetimeString();
            this.$refs.dialog.clearValidate();
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
  },
};
</script>